import React from 'react'
import Intro from './Intro'
import About from './About'
import Events from './Events/Events'
import News from './News/News'

const Main = () => {
  return (
    <>
        <Intro />
        <About />
        <News />
        <Events />

    </>
  )
}

export default Main
